var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trow"},[_c('div',{staticClass:"tcell"},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{staticClass:"tcell"},[_c('div',{class:_vm.data.checked ? 'checkmark' : 'crossmark'},[_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-icon"},[_c('span',{staticClass:"icon-line line-tip"}),_c('span',{staticClass:"icon-line line-long"}),_c('div',{staticClass:"icon-circle"})])
}]

export { render, staticRenderFns }